// import React, { useState, useEffect } from "react";
// import classes from "./CreateUserModal.module.css";
// import API from "../../../utils/api";
// import RenderToast from "../../../components/RenderToast";
// import { FiEye, FiEyeOff } from "react-icons/fi";

// const roles = [
//   { value: "admin", label: "Administrator" },
//   { value: "user", label: "User" },
// ];

// export default function CreateUserModal({ open, onClose, onCreated }) {
//   const [form, setForm] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     role: "user",
//     address: "",
//     password: "",
//   });
//   const [photoFile, setPhotoFile] = useState(null);
//   const [photoPreview, setPhotoPreview] = useState("");
//   const [saving, setSaving] = useState(false);
//   const [showPassword, setShowPassword] = useState(false);

//   useEffect(() => {
//     if (!open) {
//       setForm({ name: "", email: "", phone: "", role: "user", address: "", password: "" });
//       setPhotoFile(null);
//       setPhotoPreview("");
//     }
//   }, [open]);

//   useEffect(() => {
//     if (!photoFile) {
//       setPhotoPreview("");
//       return;
//     }
//     const objectUrl = URL.createObjectURL(photoFile);
//     setPhotoPreview(objectUrl);
//     return () => URL.revokeObjectURL(objectUrl);
//   }, [photoFile]);

//   if (!open) return null;

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setForm((prev) => ({ ...prev, [name]: value }));
//   };

//   const handlePhotoChange = (e) => {
//     const file = e.target.files?.[0];
//     if (file) {
//       setPhotoFile(file);
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!form.name || !form.email || !form.role) {
//       return RenderToast({
//         type: "error",
//         message: "Name, email, and role are required",
//       });
//     }
//     if (!form.password || form.password.length < 6) {
//       return RenderToast({
//         type: "error",
//         message: "Password is required and must be at least 6 characters",
//       });
//     }
//     if (!photoFile) {
//       return RenderToast({
//         type: "error",
//         message: "Photo is required",
//       });
//     }

//     setSaving(true);
//     try {
//       const token = localStorage.getItem("authToken") || "";
//       const formData = new FormData();
//       formData.append("action", "add");
//       formData.append("name", form.name);
//       formData.append("email", form.email);
//       formData.append("phone", form.phone || "");
//       formData.append("role", form.role);
//       formData.append("address", form.address || "");
//       formData.append("password", form.password);
//       if (photoFile) {
//         formData.append("photo", photoFile);
//       }

//       const response = await fetch(`${API.base}/users.php`, {
//         method: "POST",
//         headers: {
//           Authorization: token,
//         },
//         body: formData,
//       });
//       const data = await response.json();
//       if (!response.ok || !data.success) {
//         throw new Error(data.error || "Failed to create user");
//       }
//       RenderToast({ type: "success", message: "User created successfully" });
//       onClose();
//       onCreated?.();
//     } catch (err) {
//       RenderToast({ type: "error", message: err.message });
//     } finally {
//       setSaving(false);
//     }
//   };

//   const previewPhoto = photoPreview || "/placeholder-image.jpg";

//   return (
//     <div className={classes.backdrop} onClick={onClose}>
//       <div
//         className={classes.modal}
//         onClick={(e) => {
//           e.stopPropagation();
//         }}
//       >
//         <header className={classes.header}>
//           <div>
//             <p className={classes.kicker}>User Management</p>
//             <h3>Create New User</h3>
//           </div>
//           <button className={classes.closeBtn} onClick={onClose}>
//             ×
//           </button>
//         </header>

//         <form className={classes.form} onSubmit={handleSubmit}>
//           <div className={classes.avatarRow}>
//             <div className={classes.avatarPreview}>
//               <img src={previewPhoto} alt="Profile avatar" />
//             </div>
//             <div>
//               <p className={classes.avatarLabel}>Profile Photo *</p>
//               <p className={classes.avatarHint}>
//                 Required. Recommended size 300x300px. Supported formats: JPG, PNG, WEBP.
//               </p>
//               <label className={classes.uploadBtn}>
//                 <input
//                   type="file"
//                   accept="image/*"
//                   onChange={handlePhotoChange}
//                   required
//                 />
//                 Upload Photo
//               </label>
//             </div>
//           </div>

//           <div className={classes.grid}>
//             <label>
//               <span>Full Name *</span>
//               <input
//                 type="text"
//                 name="name"
//                 value={form.name}
//                 onChange={handleChange}
//                 placeholder="Enter full name"
//                 required
//               />
//             </label>
//             <label>
//               <span>Email Address *</span>
//               <input
//                 type="email"
//                 name="email"
//                 value={form.email}
//                 onChange={handleChange}
//                 placeholder="email@example.com"
//                 required
//               />
//             </label>
//             <label>
//               <span>Phone Number</span>
//               <input
//                 type="tel"
//                 name="phone"
//                 value={form.phone}
//                 onChange={handleChange}
//                 placeholder="+44 1234 567890"
//               />
//             </label>
//             <label>
//               <span>Role *</span>
//               <select name="role" value={form.role} onChange={handleChange} required>
//                 {roles.map((role) => (
//                   <option key={role.value} value={role.value}>
//                     {role.label}
//                   </option>
//                 ))}
//               </select>
//             </label>
//             <label>
//               <span>Password *</span>
//               <div className={classes.passwordField}>
//                 <input
//                   type={showPassword ? "text" : "password"}
//                   name="password"
//                   value={form.password}
//                   onChange={handleChange}
//                   placeholder="Enter password (min 6 characters)"
//                   required
//                   minLength={6}
//                 />
//                 <button
//                   type="button"
//                   className={classes.eyeBtn}
//                   onClick={() => setShowPassword((prev) => !prev)}
//                   aria-label={showPassword ? "Hide password" : "Show password"}
//                 >
//                   {showPassword ? <FiEyeOff /> : <FiEye />}
//                 </button>
//               </div>
//             </label>
//             <label className={classes.fullWidth}>
//               <span>Address</span>
//               <textarea
//                 name="address"
//                 value={form.address}
//                 onChange={handleChange}
//                 placeholder="Enter address"
//                 rows={3}
//               />
//             </label>
//           </div>

//           <div className={classes.actions}>
//             <button
//               type="button"
//               className={classes.secondaryBtn}
//               onClick={onClose}
//               disabled={saving}
//             >
//               Cancel
//             </button>
//             <button type="submit" className={classes.primaryBtn} disabled={saving}>
//               {saving ? "Creating..." : "Create User"}
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// }

import React, { useEffect, useMemo, useState } from "react";
import classes from "./CreateUserModal.module.css";
import API from "../../../utils/api";
import RenderToast from "../../../components/RenderToast";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { useNavigate } from "react-router-dom";

const roles = [
  { value: "admin", label: "Administrator" },
  { value: "user", label: "User" },
];

const passwordChecklistItems = [
  { key: "length", label: "At least 8 characters" },
  { key: "upper", label: "One uppercase letter (A-Z)" },
  { key: "lower", label: "One lowercase letter (a-z)" },
  { key: "number", label: "One number (0-9)" },
  { key: "special", label: "One special character (!@#$)" },
];

export default function CreateUserModal({ open, onClose, onCreated }) {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    role: "user",
    address: "",
    password: "",
  });
  const [photoFile, setPhotoFile] = useState(null);
  const [photoPreview, setPhotoPreview] = useState("");
  const [saving, setSaving] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [uploading, setUploading] = useState(false); // new
  const navigate = useNavigate();

  useEffect(() => {
    if (!open) {
      setForm({
        name: "",
        email: "",
        phone: "",
        role: "user",
        address: "",
        password: "",
      });
      setPhotoFile(null);
      setPhotoPreview("");
      setUploading(false);
    }
  }, [open]);

  useEffect(() => {
    if (!photoFile) return setPhotoPreview("");
    setUploading(true); // start loading
    const objectUrl = URL.createObjectURL(photoFile);
    setPhotoPreview(objectUrl);
    // simulate short delay for loading spinner
    const timer = setTimeout(() => setUploading(false), 500);
    return () => {
      URL.revokeObjectURL(objectUrl);
      clearTimeout(timer);
    };
  }, [photoFile]);

  const passwordChecks = useMemo(() => {
    const value = form.password || "";
    return {
      length: value.length >= 8,
      upper: /[A-Z]/.test(value),
      lower: /[a-z]/.test(value),
      number: /\d/.test(value),
      special: /[^A-Za-z0-9]/.test(value),
    };
  }, [form.password]);

  const passwordValid = useMemo(
    () => Object.values(passwordChecks).every(Boolean),
    [passwordChecks]
  );

  const strengthScore = useMemo(
    () => Object.values(passwordChecks).filter(Boolean).length,
    [passwordChecks]
  );

  const strengthLabel = useMemo(() => {
    if (strengthScore <= 2) return "Weak";
    if (strengthScore === 3 || strengthScore === 4) return "Moderate";
    return "Strong";
  }, [strengthScore]);

  if (!open) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handlePhotoChange = (e) => {
    const file = e.target.files?.[0];
    if (file) setPhotoFile(file);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmed = {
      name: (form.name || "").trim(),
      email: (form.email || "").trim(),
      phone: (form.phone || "").trim(),
      role: (form.role || "").trim(),
      address: (form.address || "").trim(),
      password: form.password || "",
    };

    if (!trimmed.name) {
      return RenderToast({ type: "error", message: "Full name is required" });
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!trimmed.email || !emailRegex.test(trimmed.email)) {
      return RenderToast({
        type: "error",
        message: "Enter a valid email address",
      });
    }
    // Phone is optional, but if provided, validate format
    if (trimmed.phone) {
      const phoneRegex = /^[0-9+\-\s()]{7,}$/;
      if (!phoneRegex.test(trimmed.phone)) {
        return RenderToast({
          type: "error",
          message: "Enter a valid phone number",
        });
      }
    }
    if (!trimmed.role) {
      return RenderToast({ type: "error", message: "Role is required" });
    }
    // Address is optional - removed required validation
    if (!trimmed.password) {
      return RenderToast({ type: "error", message: "Password is required" });
    }
    if (!passwordValid) {
      return RenderToast({
        type: "error",
        message:
          "Password must be 8+ chars and include upper, lower, number & special",
      });
    }
    if (!photoFile) {
      return RenderToast({ type: "error", message: "Photo is required" });
    }

    setSaving(true);
    try {
      const token = localStorage.getItem("authToken") || "";
      const formData = new FormData();
      formData.append("action", "add");
      formData.append("name", trimmed.name);
      formData.append("email", trimmed.email);
      formData.append("phone", trimmed.phone);
      formData.append("role", trimmed.role);
      formData.append("address", trimmed.address);
      formData.append("password", trimmed.password);
      formData.append("photo", photoFile);

      const response = await fetch(`${API.base}/users.php`, {
        method: "POST",
        headers: { Authorization: token },
        body: formData,
      });
      const data = await response.json();
      if (!response.ok || !data.success)
        throw new Error(data.error || "Failed to create user");

      RenderToast({ type: "success", message: "User created successfully" });
      onClose();
      onCreated?.();
      navigate("/users");
    } catch (err) {
      RenderToast({ type: "error", message: err.message });
    } finally {
      setSaving(false);
    }
  };

  const getImageUrl = (imageName) => {
    const baseUrl = API.base.endsWith("/serverstock_api")
      ? API.base
      : `${API.base}/serverstock_api`;

    return imageName
      ? `${baseUrl}/upload/${imageName}`
      : `${baseUrl}/upload/placeholder-image.jpg`;
  };

  const previewPhoto = photoPreview || getImageUrl();

  // const previewPhoto = photoPreview || "../placeholder-image.jpg";

  return (
    <div className={classes.backdrop} onClick={onClose}>
      <div className={classes.modal} onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <header className={classes.header}>
          <div>
            <p className={classes.kicker}>User Management</p>
            <h3>Create New User</h3>
          </div>
          <button className={classes.closeBtn} onClick={onClose}>
            ×
          </button>
        </header>

        {/* Form */}
        <form className={classes.form} onSubmit={handleSubmit}>
          {/* Avatar */}
          <div className={classes.avatarRow}>
            <div className={classes.avatarPreview}>
              {uploading && <div className={classes.avatarLoading}></div>}
              {/* <img
                src={previewPhoto}
                alt="Avatar"
                style={{ display: uploading ? "none" : "block" }}
              /> */}

              <img
                src={previewPhoto}
                alt="Avatar"
                style={{ display: uploading ? "none" : "block" }}
                onError={(e) => (e.target.src = getImageUrl())}
              />
            </div>
            <div className={classes.avatarInfo}>
              <p className={classes.avatarLabel}>Profile Photo *</p>
              <p className={classes.avatarHint}>
                Recommended: 300x300px. JPG, PNG, WEBP.
              </p>
              <label className={classes.uploadBtn}>
                <input
                  type="file"
                  accept="image/*"
                  onChange={handlePhotoChange}
                  disabled={uploading}
                  required={!photoFile}
                />
                {uploading ? "Uploading..." : "Upload Photo"}
              </label>
            </div>
          </div>

          {/* Fields */}
          <div className={classes.grid}>
            <div className={classes.field}>
              <input
                type="text"
                name="name"
                value={form.name}
                onChange={handleChange}
                placeholder="Full Name *"
                required
              />
            </div>
            <div className={classes.field}>
              <input
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                placeholder="Email Address *"
                required
              />
            </div>
            <div className={classes.field}>
              <input
                type="tel"
                name="phone"
                value={form.phone}
                onChange={handleChange}
                placeholder="Phone Number (Optional)"
              />
            </div>
            <div className={classes.field}>
              <select
                name="role"
                value={form.role}
                onChange={handleChange}
                required
              >
                {roles.map((r) => (
                  <option key={r.value} value={r.value}>
                    {r.label}
                  </option>
                ))}
              </select>
            </div>
            <div className={`${classes.field} ${classes.fieldFull}`}>
              <div className={classes.passwordField}>
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  value={form.password}
                  onChange={handleChange}
                  placeholder="Password *"
                  required
                  minLength={8}
                />
                <button
                  type="button"
                  className={classes.eyeBtn}
                  onClick={() => setShowPassword((prev) => !prev)}
                >
                  {showPassword ? <FiEyeOff /> : <FiEye />}
                </button>
              </div>
              <div className={classes.passwordStrength}>
                <div className={classes.passwordStrengthHeader}>
                  <span>Password strength:</span>
                  <span
                    className={`${classes.strengthBadge} ${
                      classes[`strength${strengthLabel}`]
                    }`}
                  >
                    {strengthLabel} ({strengthScore}/5)
                  </span>
                </div>
                <ul className={classes.passwordChecklist}>
                  {passwordChecklistItems.map((item) => (
                    <li key={item.key} data-valid={passwordChecks[item.key]}>
                      {item.label}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className={classes.fieldFull}>
              <textarea
                name="address"
                value={form.address}
                onChange={handleChange}
                placeholder="Address (Optional)"
                rows={3}
              />
            </div>
          </div>

          {/* Actions */}
          <div className={classes.actions}>
            <button
              type="button"
              className={classes.secondaryBtn}
              onClick={onClose}
              disabled={saving}
            >
              Cancel
            </button>
            <button
              type="submit"
              className={classes.primaryBtn}
              disabled={saving || uploading}
            >
              {saving ? "Creating..." : "Create User"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
